/* eslint-disable no-param-reassign */

const initialState = {
  workshopCategories: []
};

export default function workshopsReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_WORKSHOPS_SUCCESS': {
      return { ...state, workshopCategories: action.payload };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/workshops/reducer.js